import { getVisuals } from "./getVisuals";

/**
 * Get Visual by GUID field from pbiviz.json
 * @param visualGuid - string
 * @param report - powerbi.Report
 * @returns Promise<VisualDescriptor | undefined>
 */
/* istanbul ignore next */
export const getVisualByGuid = async (visualGuid: string) => {
  const visuals = await getVisuals();
  if (!visuals) {
    return null;
  }
  const regexp = new RegExp(visualGuid, "gi");
  return visuals.filter((visual) => regexp.test(visual.type)).pop() || null;
};
